module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It goes without saying that walkers and cyclists should come properly equipped to enjoy their activity. The weather is often unpredictable and it is always advisable to walk in a decent pair of boots and carry a set of waterproofs with you. Regular visitors to the battlefields will be familiar with the collections of old shells and other explosive material that are often placed by the roadside by farmers. By all means look but please do not touch as much of it is still in an unstable condition.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025ed99b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/34_fm042.vue
// module id = 159
// module chunks = 0